// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__Ujm4w","primary":"Badge_primary__08eud","secondary":"Badge_secondary__pIu7H"};